import * as yup from 'yup';

export const EmailUpdateSchema = yup.object().shape({
  email: yup.string().email('Invalid email').required('Required'),
});
